import { motion } from 'framer-motion';
import { Ban, Coins, TrendingUp, Flame } from 'lucide-react';

const highlights = [
  {
    icon: Ban,
    title: 'No VC, No Presale',
    description: '100% fair launch. No team pre-mine, no insider allocation. Community owns the timeline.',
    color: 'from-red-500/20 to-orange-500/20 border-red-500/40',
    iconColor: 'text-red-400',
  },
  {
    icon: Coins,
    title: 'Grants Build LP',
    description: 'Base Builder Grants (1–5 ETH) + crowdfund ETH go straight to Aerodrome LP. Transparent, locked.',
    color: 'from-blue-500/20 to-cyan-500/20 border-blue-500/40',
    iconColor: 'text-blue-400',
  },
  {
    icon: TrendingUp,
    title: 'Farming up to 1000% APY',
    description: 'First-month incentives. Stake $DEJA, earn. Node progression unlocks higher rewards.',
    color: 'from-green-500/20 to-emerald-500/20 border-green-500/40',
    iconColor: 'text-green-400',
  },
  {
    icon: Flame,
    title: '90%+ Revenue Burn',
    description: 'Deflationary by design. Fees and protocol revenue burn $DEJA. Supply shrinks over time.',
    color: 'from-orange-500/20 to-amber-500/20 border-orange-500/40',
    iconColor: 'text-orange-400',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-pink-400">
            Fair Launch Highlights
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Low-budget, community-built. No VC — only you and us creating the timeline.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`rounded-xl border bg-slate-800/40 backdrop-blur-sm p-6 ${item.color}`}
              whileHover={{ y: -6, scale: 1.02 }}
            >
              <item.icon className={`w-10 h-10 mb-4 ${item.iconColor}`} aria-hidden />
              <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
